import dynamic from "next/dynamic";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
const Container = dynamic(() => import("./Container"), { ssr: false });

const CountryCodePopup = ({ 
    selected, onChange, 
    popupVisible, 
    handlePopupVisible,
    titleHidden,
    columns,
    extraClasses
}) => {

    return (
        <DropdownMenu open={popupVisible} onOpenChange={handlePopupVisible}>
            <DropdownMenuTrigger asChild id="">
                <Button
                    variant="primary"
                    className={`
                        bg-transparent bg-white rounded-sm rounded-r-none
                        px-2 select-none touch-manipulation text-black
                        transition duration-150 ease-in-out
                        h-auto font-medium border-r-[1px] border-[#bdbdbd]
                        ${extraClasses}
                    `}
                    type="button"
                >
                    <span className="overflow-hidden text-ellipsis line-clamp-1">{selected}</span>

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={12}
                        height={12}
                        viewBox="0 0 24 24"
                        fill="none"
                        className="w-[12px] h-[12px]"
                    >
                        <path
                            d="M5.16108 10.0731C4.45387 9.2649 5.02785 8 6.1018 8H17.898C18.972 8 19.5459 9.2649 18.8388 10.0731L13.3169 16.3838C12.6197 17.1806 11.3801 17.1806 10.6829 16.3838L5.16108 10.0731ZM6.65274 9.5L11.8118 15.396C11.9114 15.5099 12.0885 15.5099 12.1881 15.396L17.3471 9.5H6.65274Z"
                            fill="#212121"
                        />
                    </svg>
                </Button>
            </DropdownMenuTrigger>
            <Container
                selected={selected}
                onChange={onChange}
                titleHidden={titleHidden}
                columns={columns}
            />
        </DropdownMenu>
    )
}

export default CountryCodePopup